import moment from 'moment';

import {
  CALCULATION_MLB,
  MLB,
  DAYS,
  MONTHLY,
  PERCENTAGE_35,
  INPUT_FORMAT,
  OUTPUT_FORMAT,
  DEFAULT_DISABILITY_DURATION,
  DEFAULT_UNEMPLOYMENT_DURATION,
  DEFAULT_PAYMENT_LEVEL,
  DEFAULT_CLAIM_ASSESSMENT,
  DEFAULT_WAITING_PERIOD,
} from '../enums/enums';

export function mapFormFieldsToRequestObject(formObject) {
  const {
    startDate,
    claimDuration = DEFAULT_DISABILITY_DURATION,
    claimAssessment = DEFAULT_CLAIM_ASSESSMENT,
    dateOfBirthDay,
    endDate,
    sumAssured,
    paymentLevel = DEFAULT_PAYMENT_LEVEL,
    unemploymentClaimDuration = DEFAULT_UNEMPLOYMENT_DURATION,
    waitingPeriod = DEFAULT_WAITING_PERIOD,
    isUnemploymentSelected,
    unemploymentSumAssured = DEFAULT_UNEMPLOYMENT_DURATION,
  } = formObject;

  const dateOfBirth = moment(dateOfBirthDay, INPUT_FORMAT).format(OUTPUT_FORMAT);
  const policyStartDate = moment(startDate, INPUT_FORMAT).format(OUTPUT_FORMAT);
  const firstDayOfNextMonthEndDate = moment(moment(endDate, INPUT_FORMAT).add(1, DAYS)).format(OUTPUT_FORMAT);

  const requestDisabilityEntity = {
    type: CALCULATION_MLB,
    productType: MLB,
    dateOfCommencement: policyStartDate,
    paymentMethod: MONTHLY,
    disabilityCover: {
      sumAssured,
      paymentLevel: paymentLevel.valueField,
      startDate: policyStartDate,
      endDate: firstDayOfNextMonthEndDate,
      coverLimit: PERCENTAGE_35,
      claimAssessment: claimAssessment.valueField,
      claimDuration: claimDuration.valueField,
      waitingPeriod: waitingPeriod.valueField,
      insuredAttributes: {
        dateOfBirth,
      },
    },
  };

  if (isUnemploymentSelected) {
    requestDisabilityEntity.unemploymentCover = {
      sumAssured: unemploymentSumAssured,
      startDate: policyStartDate,
      endDate: firstDayOfNextMonthEndDate,
      claimDuration: unemploymentClaimDuration.valueField,
      insuredAttributes: {
        dateOfBirth,
      },
    };
  }

  return requestDisabilityEntity;
}
